(() => {
  const MOBILE_BREAKPOINT = 989;
  const TRANSITION_DURATION = 320;

  const initChefCurveCarousel = () => {
    document
      .querySelectorAll('[data-gc-impact-curve]')
      .forEach((section) => {
        const stage = section.querySelector(
          '.gc-impact-curve-stage'
        );

        const items = Array.from(
          section.querySelectorAll(
            '.gc-impact-curve-item'
          )
        );

        const prev = section.querySelector(
          '[data-gc-impact-curve-prev]'
        );

        const next = section.querySelector(
          '[data-gc-impact-curve-next]'
        );

        const pageLabel = section.querySelector(
          '[data-gc-impact-curve-page]'
        );

        if (
          !stage ||
          !items.length ||
          !prev ||
          !next
        ) {
          return;
        }

        const getPerPage = () => {
          if (window.innerWidth <= MOBILE_BREAKPOINT) {
            return 3;
          }

          return 5;
        };

        const getSlots = (
          count,
          perPage
        ) => {
          /*
            Desktop keeps five curved positions.
            Tablet / iPad / mobile returns to three cards
            with a clear left-low / centre-high / right-low curve.
          */

          if (perPage === 5) {
            if (count <= 1) {
              return [3];
            }

            if (count === 2) {
              /*
                Desktop remainder page with two cards:
                use dedicated centre slots so the pair stays
                close together while still following a small curve.
              */
              return [6, 7];
            }

            if (count === 3) {
              return [2, 3, 4];
            }

            if (count === 4) {
              return [1, 2, 4, 5];
            }

            return [1, 2, 3, 4, 5];
          }

          if (perPage === 3) {
            if (count <= 1) {
              return [2];
            }

            if (count === 2) {
              return [1, 3];
            }

            return [1, 2, 3];
          }

          return Array.from(
            { length: count },
            (_, index) => index + 1
          );
        };

        let currentPage = Number(
          section.dataset.gcChefPage || 0
        );

        let isAnimating = false;
        let transitionTimer = null;

        const updateItems = () => {
          const perPage = getPerPage();

          const totalPages = Math.max(
            1,
            Math.ceil(
              items.length / perPage
            )
          );

          currentPage =
            (
              (
                currentPage %
                totalPages
              ) +
              totalPages
            ) %
            totalPages;

          section.dataset.gcChefPage =
            String(currentPage);

          const start =
            currentPage * perPage;

          const visibleItems = items.slice(
            start,
            start + perPage
          );

          const slots = getSlots(
            visibleItems.length,
            perPage
          );

          items.forEach((item) => {
            item.classList.remove(
              'is-visible',
              'is-entering',
              'is-leaving',
              'is-slot-1',
              'is-slot-2',
              'is-slot-3',
              'is-slot-4',
              'is-slot-5',
              'is-slot-6',
              'is-slot-7',
              'is-slot-8'
            );

            item.setAttribute(
              'aria-hidden',
              'true'
            );

            item.tabIndex = -1;
          });

          visibleItems.forEach(
            (
              item,
              index
            ) => {
              item.classList.add(
                'is-visible',
                'is-entering',
                'is-slot-' + slots[index]
              );

              item.setAttribute(
                'aria-hidden',
                'false'
              );

              item.tabIndex = 0;
            }
          );

          if (pageLabel) {
            pageLabel.textContent =
              `${currentPage + 1} / ${totalPages}`;
          }

          prev.hidden =
            totalPages <= 1;

          next.hidden =
            totalPages <= 1;

          prev.disabled =
            totalPages <= 1;

          next.disabled =
            totalPages <= 1;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              visibleItems.forEach((item) => {
                item.classList.remove(
                  'is-entering'
                );
              });

              section.classList.remove(
                'is-changing'
              );

              isAnimating = false;
            });
          });
        };

        const renderImmediately = () => {
          window.clearTimeout(
            transitionTimer
          );

          isAnimating = false;

          section.classList.remove(
            'is-changing'
          );

          updateItems();
        };

        const changePage = (
          direction
        ) => {
          if (isAnimating) {
            return;
          }

          const perPage = getPerPage();

          const totalPages = Math.max(
            1,
            Math.ceil(
              items.length / perPage
            )
          );

          if (totalPages <= 1) {
            return;
          }

          isAnimating = true;

          section.classList.add(
            'is-changing'
          );

          const currentlyVisible =
            items.filter((item) =>
              item.classList.contains(
                'is-visible'
              )
            );

          currentlyVisible.forEach(
            (item) => {
              item.classList.add(
                'is-leaving'
              );
            }
          );

          transitionTimer =
            window.setTimeout(() => {
              currentPage += direction;

              updateItems();
            }, TRANSITION_DURATION);
        };

        if (
          section.dataset.gcChefCurveReady !==
          'true'
        ) {
          section.dataset.gcChefCurveReady =
            'true';

          prev.addEventListener(
            'click',
            () => {
              changePage(-1);
            }
          );

          next.addEventListener(
            'click',
            () => {
              changePage(1);
            }
          );

          section.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                changePage(-1);
              }

              if (event.key === 'ArrowRight') {
                event.preventDefault();
                changePage(1);
              }
            }
          );
        }

        section._gcChefRenderImmediately =
          renderImmediately;

        renderImmediately();
      });
  };

  const bindGreenChefImpactCurveSwipe = () => {
    document
      .querySelectorAll(
        '[data-gc-impact-curve]'
      )
      .forEach((section) => {
        const stage =
          section.querySelector(
            '.gc-impact-curve-stage'
          ) ||
          section.querySelector(
            '.gc-impact-curve'
          ) ||
          section.querySelector(
            '.gc-impact-curve-wrap'
          );

        if (
          !stage ||
          stage.dataset.gcSwipeReady ===
            'true'
        ) {
          return;
        }

        stage.dataset.gcSwipeReady =
          'true';

        stage.style.touchAction =
          'pan-y';

        stage.style.cursor =
          'grab';

        let startX = 0;
        let startY = 0;
        let latestX = 0;
        let latestY = 0;
        let tracking = false;
        let activePointerId = null;

        const findControl = (
          direction
        ) => {
          const selectors =
            direction === 'next'
              ? [
                  '[data-gc-impact-curve-next]',
                  '.gc-impact-curve-next',
                  '.gc-impact-next',
                  '[data-gc-impact-next]',
                  '[data-gc-curve-next]',
                  '[aria-label*="Next"]',
                  '[aria-label*="next"]'
                ]
              : [
                  '[data-gc-impact-curve-prev]',
                  '.gc-impact-curve-prev',
                  '.gc-impact-prev',
                  '[data-gc-impact-prev]',
                  '[data-gc-curve-prev]',
                  '[aria-label*="Previous"]',
                  '[aria-label*="previous"]',
                  '[aria-label*="Prev"]',
                  '[aria-label*="prev"]'
                ];

          for (
            let index = 0;
            index < selectors.length;
            index += 1
          ) {
            const control =
              section.querySelector(
                selectors[index]
              );

            if (control) {
              return control;
            }
          }

          return null;
        };

        const activate = (
          direction
        ) => {
          const control =
            findControl(direction);

          if (
            control &&
            !control.disabled &&
            !control.hidden
          ) {
            control.click();
          }
        };

        const resetTracking = () => {
          tracking = false;
          activePointerId = null;

          stage.classList.remove(
            'is-dragging'
          );

          stage.style.cursor =
            'grab';
        };

        const finishSwipe = () => {
          if (!tracking) {
            return;
          }

          const deltaX =
            latestX - startX;

          const deltaY =
            latestY - startY;

          resetTracking();

          const threshold = 42;

          if (
            Math.abs(deltaX) <
            threshold
          ) {
            return;
          }

          if (
            Math.abs(deltaX) <=
            Math.abs(deltaY) * 1.15
          ) {
            return;
          }

          activate(
            deltaX < 0
              ? 'next'
              : 'prev'
          );
        };

        stage.addEventListener(
          'pointerdown',
          (event) => {
            if (
              window.innerWidth >
              MOBILE_BREAKPOINT
            ) {
              return;
            }

            if (
              event.pointerType === 'mouse'
            ) {
              return;
            }

            activePointerId =
              event.pointerId;

            startX =
              latestX =
                event.clientX;

            startY =
              latestY =
                event.clientY;

            tracking = true;

            stage.classList.add(
              'is-dragging'
            );

            stage.style.cursor =
              'grabbing';

            if (
              typeof stage.setPointerCapture ===
              'function'
            ) {
              stage.setPointerCapture(
                event.pointerId
              );
            }
          }
        );

        stage.addEventListener(
          'pointermove',
          (event) => {
            if (
              !tracking ||
              event.pointerId !==
                activePointerId
            ) {
              return;
            }

            latestX =
              event.clientX;

            latestY =
              event.clientY;
          }
        );

        stage.addEventListener(
          'pointerup',
          (event) => {
            if (
              event.pointerId !==
              activePointerId
            ) {
              return;
            }

            finishSwipe();
          }
        );

        stage.addEventListener(
          'pointercancel',
          resetTracking
        );

        stage.addEventListener(
          'lostpointercapture',
          () => {
            if (tracking) {
              finishSwipe();
            }
          }
        );
      });
  };

  const initialize = () => {
    initChefCurveCarousel();
    bindGreenChefImpactCurveSwipe();
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    initialize
  );

  window.addEventListener(
    'resize',
    () => {
      window.clearTimeout(
        window.__gcChefCurveResizeTimer
      );

      window.__gcChefCurveResizeTimer =
        window.setTimeout(() => {
          document
            .querySelectorAll(
              '[data-gc-impact-curve]'
            )
            .forEach((section) => {
              if (
                typeof
                  section._gcChefRenderImmediately ===
                'function'
              ) {
                section._gcChefRenderImmediately();
              }
            });
        }, 180);
    }
  );
})();